module.exports = __webpack_public_path__ + "static/img/nodata.761ec65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata.png
// module id = f0hK
// module chunks = 29